import Menu, { MenuProps } from '@mui/material/Menu';

export const PopupMenu = (
  props: MenuProps & {
    align?: 'left' | 'right' | 'center';
  }
) => {
  const align = props.align || 'center';
  const leftValue = {
    left: 14,
    center: 'calc(50% - 5px)',
    right: undefined
  }
  const rightValue = {
    left: undefined,
    center: undefined,
    right: 14
  }
  return (
    <Menu
      PaperProps={{
        elevation: 0,
        sx: {
          overflow: 'visible',
          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
          mt: 1.5,
          '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            // ml: -0.5,
            // mr: 1,
          },
          '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            left: leftValue[align],
            right: rightValue[align],
            width: 10,
            height: 10,
            bgcolor: 'background.paper',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
            
          },
        },
      }}
      transformOrigin={{ horizontal: align, vertical: 'top' }}
      anchorOrigin={{ horizontal: align, vertical: 'bottom' }}
      {...props}
    />
  );
};
